import { motion } from "framer-motion";

type StepIndicatorProps = {
  currentStep: number;
  totalSteps: number;
};

const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps) => {
  return (
    <div className="flex items-center mb-8">
      <div className="w-full flex items-center space-x-3">
        <div className="flex-none text-sm text-gray-500">
          {currentStep} of {totalSteps}
        </div>
        <div className="flex-grow h-2 bg-gray-100 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: `${((currentStep - 1) / totalSteps) * 100}%` }}
            animate={{ width: `${(currentStep / totalSteps) * 100}%` }}
            transition={{ duration: 0.3 }}
            className="h-full bg-primary-500 rounded-full"
          />
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
